import styled from "styled-components";
import { motion } from "framer-motion";
import {
  EmptyText as SharedEmptyText,
  getToneTokens,
  PageActions,
  PageContainer,
  PageState as SharedPageState,
  PageTitle,
  PageTopBar,
  Section,
  SectionTitle,
  TableWrapper,
  TabButton,
  Tabs as SharedTabs,
} from "../../styles/shared";

export const Wrapper = styled(PageContainer)``;

export const PageState = styled(SharedPageState)``;

export const TopBar = styled(PageTopBar)``;

export const Titulo = styled(PageTitle)``;

export const TopBarActions = styled(PageActions)``;

export const Abas = styled(SharedTabs)``;

export const Aba = styled(TabButton)``;

export const Secao = styled(Section)``;

export const SecaoTitulo = styled(SectionTitle)``;

export const EtapaRow = styled(motion.div)`
  display: grid;
  grid-template-columns: minmax(180px, 240px) 1fr minmax(110px, 140px);
  align-items: center;
  gap: 12px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const EtapaLabel = styled.div`
  font-size: 13px;
  color: ${({ theme }) => theme.textPrimary};
`;

export const TipoQtd = styled.span`
  font-size: 11px;
  color: ${({ theme }) => theme.textSecondary};
`;

export const BarraWrap = styled.div`
  height: 10px;
  background: ${({ theme }) => theme.surfaceAlt};
  border-radius: 999px;
  overflow: hidden;
`;

export const Barra = styled.div`
  height: 100%;
  background: ${({ theme }) => theme.accent};
  border-radius: 999px;
  width: ${({ $width = "0%" }) => $width};
  transition: width 0.6s cubic-bezier(0.16, 1, 0.3, 1);
`;

export const EtapaStats = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  @media (max-width: 768px) {
    align-items: flex-start;
  }
`;

export const StatValor = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: ${({ theme }) => theme.textPrimary};
`;

export const StatMinMax = styled.div`
  font-size: 11px;
  color: ${({ theme }) => theme.textSecondary};
`;

export const DuasColunas = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 24px;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

export const ClienteTabelaWrapper = styled(TableWrapper)``;

export const ClienteTabela = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  min-width: 520px;
`;

export const Th = styled.th`
  /* Bugfix #13 (2026-05-29): sticky header amplo. */
  position: sticky;
  top: var(--app-header-height, 0px);
  z-index: 5;
  padding: 10px 12px;
  text-align: left;
  background: ${({ theme }) => theme.surfaceAlt};
  color: ${({ theme }) => theme.textSecondary};
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-bottom: 1px solid ${({ theme }) => theme.border};
  white-space: nowrap;
`;

export const Td = styled.td`
  padding: 9px 12px;
  border-bottom: 1px solid ${({ theme }) => theme.border};
  color: ${({ theme }) => theme.textPrimary};
`;

export const TdDestaque = styled(Td)`
  font-weight: 700;
  color: ${({ theme, $tone = "default" }) => getToneTokens(theme, $tone).text};
`;

export const EmptyText = styled(SharedEmptyText)``;
